// extracted by mini-css-extract-plugin
export var externalLink = "_8v-0";
export var internalLinkLabel = "_8v-1";